import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { serverUrlAuth } from '../../serverUrl';

// Async thunks
export const fetchArtisanAcceptedProjects = createAsyncThunk(
  'projects/fetchArtisanAcceptedProjects',
  async (_, { rejectWithValue }) => {
    try {
      const response = await serverUrlAuth.get('projects/accepted-projects/');
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const submitProgressUpdate = createAsyncThunk(
  'projects/submitProgressUpdate',
  async ({ projectId, formData }, { rejectWithValue }) => {
    try {
      const response = await serverUrlAuth.post(
        `updates/project-updates/${projectId}/`,
        formData,
        
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const projectsSlice = createSlice({
  name: 'projects',
  initialState: {
    projects: [],
    selectedProjectForDetails: null,
    selectedProjectForUpdate: null,
    activeImage: 0,
    showUpdateModal: false,
    progressForm: {
      progress: '',
      note: '',
      uploaded_images: [],
    },
    loading: false,
    submitting: false,
    error: null,
  },
  reducers: {
    setSelectedProjectForDetails: (state, action) => {
      state.selectedProjectForDetails = action.payload;
    },
    setSelectedProjectForUpdate: (state, action) => {
      state.selectedProjectForUpdate = action.payload;
    },
    setActiveImage: (state, action) => {
      state.activeImage = action.payload;
    },
    setShowUpdateModal: (state, action) => {
      state.showUpdateModal = action.payload;
    },
    setProgressForm: (state, action) => {
      state.progressForm = { ...state.progressForm, ...action.payload };
    },
    resetProgressForm: (state) => {
      state.progressForm = {
        progress: '',
        note: '',
        uploaded_images: [],
      };
    },
    addUploadedImages: (state, action) => {
      state.progressForm.uploaded_images = [
        ...state.progressForm.uploaded_images,
        ...action.payload,
      ];
    },
    removeUploadedImage: (state, action) => {
      state.progressForm.uploaded_images = state.progressForm.uploaded_images.filter(
        (_, index) => index !== action.payload
      );
    },
    clearUploadedImages: (state) => {
      state.progressForm.uploaded_images = [];
    },
    clearError: (state) => {
      state.error = null;
    },
    resetProjectsState: (state) => {
      state.projects = [];
      state.selectedProjectForDetails = null;
      state.selectedProjectForUpdate = null;
      state.activeImage = 0;
      state.showUpdateModal = false;
      state.progressForm = {
        progress: '',
        note: '',
        uploaded_images: [],
      };
      state.loading = false;
      state.submitting = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch projects
      .addCase(fetchArtisanAcceptedProjects.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchArtisanAcceptedProjects.fulfilled, (state, action) => {
        state.loading = false;
        // state.projects = action.payload.map((p) => ({
        //   id: p.id,
        //   title: p.title,
        //   client: p.client,
        //   amount: parseFloat(p.budget) || 0,
        //   status:
        //     p.status === 'in-progress'
        //       ? 'In Progress'
        //       : p.status === 'completed'
        //       ? 'Completed'
        //       : 'Pending',
        //   startDate: p.created_at,
        //   deadline: p.deadline,
        //   progress: p.status === 'completed' ? 100 : (p.progress ?? 0),

        //   images: (p.images || []).map((img) => img.image),
        //   description: p.description || '',
        //   unread_updates: p.unread_updates ?? 0,
        // }));
        state.projects = action.payload.map((p) => ({
          id: p.id,
          title: p.title,
          client: p.client,
          amount: parseFloat(p.budget) || 0,
          status:
            p.status === 'in-progress'
              ? 'In Progress'
              : p.status === 'completed'
              ? 'Completed'
              : 'Pending',
          startDate: p.created_at,
          deadline: p.deadline,
          progress: p.status === 'completed' ? 100 : (p.progress ?? 0),

          images: (p.images || []).map((img) => img.image),
          description: p.description || '',
          unread_updates: p.unread_updates ?? 0,
        }));
      })
      .addCase(fetchArtisanAcceptedProjects.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // Submit progress update
      .addCase(submitProgressUpdate.pending, (state) => {
        state.submitting = true;
        state.error = null;
      })
      .addCase(submitProgressUpdate.fulfilled, (state) => {
        state.submitting = false;
        state.showUpdateModal = false;
        state.selectedProjectForUpdate = null;
        state.progressForm = {
          progress: '',
          note: '',
          uploaded_images: [],
        };
      })
      .addCase(submitProgressUpdate.rejected, (state, action) => {
        state.submitting = false;
        state.error = action.payload;
      });
  },
});

export const {
  setSelectedProjectForDetails,
  setSelectedProjectForUpdate,
  setActiveImage,
  setShowUpdateModal,
  setProgressForm,
  resetProgressForm,
  addUploadedImages,
  removeUploadedImage,
  clearUploadedImages,
  clearError,
  resetProjectsState,
} = projectsSlice.actions;

export default projectsSlice.reducer;